import React from 'react'

const Manual_invukds_configuracion_pantallas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
      <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        InvuKDS Configuración - Pantallas
      </h2>
      <p className="text-lg text-gray-700 mb-6">
        Esta guía proporciona instrucciones esenciales para configurar la pantalla de InvuKDS,
        permitiendo a los usuarios personalizar el tema y el diseño según sus preferencias.
        Simplifica la selección de opciones visuales como "Mosaico", "Clásico" o "Dividido",
        garantizando una experiencia de visualización óptima para las pantallas de comando.
      </p>
      <iframe
        src="https://scribehow.com/embed/InvuKDS_Configuracion__Pantallas__XOEm5V0MTGq_O4Lwf7wPKw?as=scrollable"
        className="scribe-iframe-general-6"
        width="100%"
        height="4600"
        allowFullScreen
        style={{ border: 0, minHeight: '480px' }}
      ></iframe>
    </div>
  </div>
  )
}

export default Manual_invukds_configuracion_pantallas